export default "__VITE_ASSET__ZdKZ0hKx__"